import React, { useState } from 'react'
import { connect } from 'react-redux'
import styled from 'styled-components'

// Actions
import { topBusinessDebtorsActions } from '../_actions'

// Components
import Field from './FieldNew'
import { Button } from './Button'
import { FaTrashAlt } from 'react-icons/fa'
import { useEffect } from 'react'

// Styled Components
const StyledLargestCustomers = styled.div`
  display: flex;
  flex-direction: column;

  .customers {
    margin-top: 15px;
    display: flex;
    flex-direction: column;
  }

  .customer-title {
    font-size: 20px;
    display: flex;
    width: 100%;
    justify-content: space-between;
    min-height: 34px;
  }

  .add-customer-btn {
    margin-top: 25px;
  }
`

const LargestCustomers = ({
  data,
  fields,
  label,
  values,
  handleBlur,
  handleChange,
  errors,
  touched,
  businessId,
  addTopBusinessDebtor,
  fieldStateUpdate,
  overrideShowError,
  handleCustomerRemove,
  required = false,
  maxLength = 3,
}) => {
  const [showTrash, setShowTrash] = useState(data.map((cus) => !cus.id))

  useEffect(() => {
    if (showTrash.length < data.length) {
      setShowTrash(data.map((cus) => !cus.id))
    }
  })

  return (
    <StyledLargestCustomers className={`largest-customers`}>
      {data.length === 0 ? (
        <p>You have not entered any {label.toLowerCase()}.</p>
      ) : (
        data.map((customer, i) => {
          return (
            <div className={`customers`} key={`${i}_${customer?.id || i}`}>
              <h4 className="customer-title">
                {label} {i + 1}
                {
                  <Button
                    className={`compact`}
                    onClick={() => handleCustomerRemove(customer?.id, i + 1, businessId)}
                    type={'button'}
                  >
                    <FaTrashAlt />
                  </Button>
                }
              </h4>
              {fields.map((field, ii) => (
                <Field
                  errors={errors}
                  field={{
                    ...field,
                    required: i === 0 ? field.required : false,
                  }}
                  fieldStateUpdate={fieldStateUpdate}
                  handleBlur={(name, attr, val) => {
                    let newTrash = [...showTrash]
                    newTrash[i] = true
                    setShowTrash(newTrash)
                    return handleBlur(name, attr, val, i)
                  }}
                  // handleBlur={(name, attr, val) => customHandleBlur(name, attr, val)}
                  handleChange={handleChange}
                  index={i}
                  key={`${ii}_${customer?.id || ii}`}
                  onFocus={(e) => {
                    let newTrash = [...showTrash]
                    newTrash[i] = false
                    setShowTrash(newTrash)
                  }}
                  overrideShowError={overrideShowError}
                  touched={touched}
                  values={values}
                />
              ))}
            </div>
          )
        })
      )}
      {data.length < maxLength && (
        <div className={`add-customer-btn`}>
          <Button
            buttonType={`button`}
            onClick={() => addTopBusinessDebtor()}
            text={`Add ${(data.length == 0 ? '' : 'Another ') + label}`}
            type={`button`}
          />
        </div>
      )}
    </StyledLargestCustomers>
  )
}

function mapStateToProps(state) {
  const { business } = state
  return {
    businessId: business.id,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    addTopBusinessDebtor: () => {
      dispatch(topBusinessDebtorsActions.addTopBusinessDebtor())
    },
  }
}

const connectedLargestCustomers = connect(mapStateToProps, mapDispatchToProps)(LargestCustomers)
export { connectedLargestCustomers as LargestCustomers }
